import { find, findIndex } from "lodash";

export enum MerchantServiceStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

// Employees at the shop who offer the given business service.
export const getServiceProviders = ({ account, shopKey, serviceId }: any) =>
  find(account.shops, (sp) => sp.key === shopKey).serviceProviders.filter(
    (sp: any) => {
      const spBusinessServices = sp.services.map((s: any) => ({
        id: s.businessService.id,
        status: s.status,
      }));

      return (
        findIndex(
          spBusinessServices,
          ({ id, status }: { id: number; status: MerchantServiceStatus }) =>
            id === Number(serviceId) && status === MerchantServiceStatus.ACTIVE
        ) > -1
      );
    }
  );

export const getServicesByProvider = ({ account, shopKey, providerId }: any) => {
  const shop = find(account.shops, (sp) => sp.key === shopKey);

  if (!shop) return [];

  const provider = find(
    shop.serviceProviders,
    (sp: any) => sp.id === Number(providerId)
  );

  if (!provider) return [];

  return provider.services;
};
